import EventManager from 'libs/EventManager';

export const toggleEventManager = new EventManager();

export default function toggleDrawer() {
  toggleEventManager.emit('toggledrawer');
}
